import { useState } from 'react';
import Modal from '../Modal';
import Button from '../Button';
import Alert from '../Alert';
import { disableEnterpriseClasses } from '../../api/admin';

/**
 * 「关闭班级分流」警告弹窗（不可逆，勾选确认后才可提交）。
 *
 * Props:
 *   entId            企业 id
 *   activeClassCount 当前活跃班级数（填进警告文案）
 *   onClose          关闭
 *   onDone           成功回调（父级据此刷新企业形态）
 */
export default function DisableClassesModal({ entId, activeClassCount = 0, onClose, onDone }) {
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!confirmed) { setError('请先勾选确认'); return; }
    setSaving(true); setError('');
    try {
      await disableEnterpriseClasses(entId);
      onDone?.();
    } catch (e) {
      setError(e.response?.data?.detail || '操作失败');
      setSaving(false);
    }
  };

  return (
    <Modal
      open
      onClose={onClose}
      title="关闭班级分流"
      maxWidth={520}
      footer={
        <>
          <Button variant="secondary" size="sm" onClick={onClose}>取消</Button>
          <Button variant="danger" size="sm" onClick={handleSubmit} loading={saving} disabled={!confirmed}>
            确认关闭
          </Button>
        </>
      }
    >
      {error && <Alert type="error">{error}</Alert>}
      <Alert type="warning">
        <div style={{ fontWeight: 600, marginBottom: 8 }}>此操作将：</div>
        <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
          <li>归档全部 {activeClassCount} 个活跃班级（成员关系保留，可在“归档班级”查看历史）</li>
          <li>企业看板切换为“全员聚合”形态</li>
          <li>注册码改回裸码（带班级编号的码立即失效）</li>
          <li>新员工注册后直接绑企业，不进入任何班级</li>
        </ul>
        <div style={{ fontWeight: 700, marginTop: 10 }}>此操作不可逆，是否继续？</div>
      </Alert>
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginTop: 4 }}>
        <input type="checkbox" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} />
        <span style={{ fontSize: 13, color: '#374151' }}>我已了解后果，确认关闭班级分流</span>
      </label>
    </Modal>
  );
}
